import { ApolloError as ApolloClientError } from "@apollo/client"
import { Text } from "@chakra-ui/react"

// TODO: add a Error component that can render errors more elegantly.
function ApolloError({ error }: { error?: ApolloClientError }) {
  return error instanceof ApolloClientError ? (
    <Text>{error.message.split("GraphQL error: ").join("")}</Text>
  ) : null
}

export default ApolloError
